import React, { useEffect, useState } from 'react';
import './index.css';

const NewHome: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);
    return (
        <div className="app">
            {/* Animated Grid Background */}
            <div className="grid-background" />
            <div className="scanline" />

            {/* Header */}
            <header className={`header ${isVisible ? 'visible' : ''}`}>
                <div className="container">
                    <nav className="nav">
                        <div className="logo">
                            <span className="prompt">&gt; </span>
                            mmetja.kekana
                        </div>
                    </nav>
                </div>
            </header>

            {/* Hero Section */}
            <section className="hero">
                <div className="container">
                    <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
                        <div className="terminal-prompt">
                            <span>user@terminal</span>:~$ whoami
                        </div>
                        {/*<h1>*/}
                        {/*    <span className="name-first">Mmetja P.</span>*/}
                        {/*    <br />*/}
                        {/*    <span className="name-last">Kekana</span>*/}
                        {/*</h1>*/}
                        <p className="subtitle">Software & Solutions Architect and Engineer</p>
                        <p className="bio">
                            I architect systems that scale and code that ships.
                            Some solve business problems, others solve my curiosity. <br/>
                              </p>
                    </div>
                </div>
            </section>

            {/* Links Section */}
            <section className="links">
                <div className="container">
                    <div className="links-grid">
                        <a href="https://unit326.com" className="link-card" target="_blank" rel="noopener noreferrer">
                            <div className="link-icon">{'>'}_</div>
                            <h3>My endless side projects</h3>
                            <p className={"name-last text-xs"}>(Because 9-5 pays the bills and side projects feed the soul)</p>

                            <p>Unit 326 Projects</p>
                            <span className="link-arrow">→</span>
                        </a>

                        <a href="https://medium.com/@mmetjakekana" className="link-card" target="_blank" rel="noopener noreferrer">
                            <div className="link-icon">~/</div>
                            <h3>Sometimes I write things</h3>
                            <p>Springboot monitoring with Prometheus and Grafana</p>
                            <span className="link-arrow">→</span>
                        </a>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section className="contact">
                <div className="container">
                    <div className="contact-content">
                        <h2 className="contact-title">Let's Connect</h2>
                        <div className="contact-links">

                            <a href="https://github.com/mmetja" className="contact-link" target="_blank" rel="noopener noreferrer">
                                <span>→</span> GitHub
                            </a>
                            <a href="https://www.linkedin.com/in/mmetja-kekana-95801a150/" className="contact-link" target="_blank" rel="noopener noreferrer">
                                <span>→</span> LinkedIn
                            </a>
                            <a href="https://twitter.com/mmetjakekana" className="contact-link" target="_blank" rel="noopener noreferrer">
                                <span>→</span> Twitter
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer>
                <div className="container">
                    <p>&copy; {new Date().getFullYear()} Mmetja P. Kekana</p>
                </div>
            </footer>
        </div>
    );

}

export default NewHome;
